import type React from "react";
import type { ReactNode } from "react";
import ErrorBoundary from "@/components/errorHandling/ErrorBoundary";
import { useTabs } from "@/context/tabs/TabsContext";

interface ErrorBoundaryProviderProps {
	children: ReactNode;
}

export const ErrorBoundaryProvider: React.FC<ErrorBoundaryProviderProps> = ({
	children,
}) => {
	const { resetState } = useTabs();

	const handleError = () => {
		setTimeout(() => {
			resetState();
		}, 0);
	};

	return <ErrorBoundary onError={handleError}>{children}</ErrorBoundary>;
};
